module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/flow-image04-44bf35e9eddce0e4eb4cd0485b19af93.png";